(() => {
  const REVEAL_ROOT = null;
  const REVEAL_ROOT_MARGIN = '0px 0px -40px 0px';
  const REVEAL_THRESHOLD = 0;
  const REVEAL_DELAY_PROPERTY = '--reveal-delay';

  const BOUND = 'data-reveal-bound';
  const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  const applyDelay = (element) => {
    const raw = element.getAttribute('data-reveal-delay');
    if (!raw) return;

    const value = Number(raw);
    if (!Number.isFinite(value) || value <= 0) return;

    element.style.setProperty(REVEAL_DELAY_PROPERTY, `${value}ms`);
  };

  const collect = (root) => {
    const elements = [];

    if (root instanceof Element && root.matches('[data-reveal]') && !root.hasAttribute(BOUND)) {
      elements.push(root);
    }

    root.querySelectorAll('[data-reveal]').forEach((element) => {
      if (!element.hasAttribute(BOUND)) elements.push(element);
    });

    return elements;
  };

  const markRevealed = (element) => {
    element.classList.add('is-revealed');
  };

  const setup = (root) => {
    const elements = collect(root);
    if (!elements.length) return;

    elements.forEach((element) => {
      element.setAttribute(BOUND, '');
      applyDelay(element);
    });

    if (motionQuery.matches) {
      elements.forEach(markRevealed);
      return;
    }

    const groups = new Map();

    elements.forEach((element) => {
      const name = element.getAttribute('data-reveal-group');
      if (!name) return;
      if (!groups.has(name)) groups.set(name, []);
      groups.get(name).push(element);
    });

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          const groupName = entry.target.getAttribute('data-reveal-group');
          const targets = groupName ? groups.get(groupName) || [entry.target] : [entry.target];

          targets.forEach((element) => {
            markRevealed(element);
            observer.unobserve(element);
          });
        });
      },
      {
        root: REVEAL_ROOT,
        rootMargin: REVEAL_ROOT_MARGIN,
        threshold: REVEAL_THRESHOLD
      }
    );

    elements.forEach((element) => observer.observe(element));
  };

  setup(document);

  document.addEventListener('shopify:section:load', (event) => {
    setup(event.target);
  });
})();
